import { Http } from '@/services/http'
import { InvokeThrottle } from '@/common/decorators/_api'
import { ParamsClean } from '@/common/decorators/params-clean'
import { Injectable } from '@tanbo/vue-di-plugin'

export interface QueryParams {
  key_word: string
  /** 秒级时间戳，由页面 useParseTime 写入 */
  start_time?: number | string
  /** 秒级时间戳，由页面 useParseTime 写入 */
  end_time?: number | string
  sort: string
  asc: boolean
  page: number
  limit: number
}

export interface HardwareModifyData {
  device_id: string
  create_time: string
  computer_name: string
  user_mark: string
  group_name: string
  client_ip: string
  system_ip: string
  mac: string
  item_type: number
  origin_setting: string
  new_setting: string
}

@Injectable()
export class HardwareModifyLogService {
  constructor (private http: Http) {
  }

  @ParamsClean()

  @InvokeThrottle()
  getHardwareModifyList (params: Partial<QueryParams>) {
    return this.http.post<{
      total: number
      list: HardwareModifyData[]
    }>('/logmanage/hardware-change/list', params)
  }

  download (type: 0|1, options: Partial<QueryParams>, moduleName: string) {
    const params = Object.assign({}, options, {
      file_type: type,
      page: 0, // 不分页
      limit: 0
    })
    return this.http.downloadWithBlob('/logmanage/hardware-change/list/export', params, moduleName)
  }
}

const CREATE_TIME_COLUMN = 'create_time'
export function computedDefaultSort (query: any = {}, options: QueryParams) {
  if (query?.sort === CREATE_TIME_COLUMN) {
    options.sort = CREATE_TIME_COLUMN
    const asc = query.asc === 'true'
    options.asc = asc
    return {
      prop: CREATE_TIME_COLUMN,
      order: asc ? 'ascending' : 'descending'
    }
  }
  return {}
}
